/**
 * Keyboard shortcut labels in each platform's own convention, as most
 * cross-platform web apps show them: symbols on a Mac (⌥1, ⌘S, ⇧⌘S) and
 * named keys elsewhere (Alt+1, Ctrl+S, Ctrl+Shift+S).
 *
 * Only the label changes — the shortcuts themselves are the same keys on
 * every platform (TipTap's "Mod" is ⌘ on a Mac and Ctrl elsewhere).
 */

export const isMac =
  typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent || '');

const MAC_SYMBOLS = { Alt: '⌥', Shift: '⇧', Mod: '⌘' };
const MAC_ORDER = ['Alt', 'Shift', 'Mod'];       // Apple's order: ⌥⇧⌘
const OTHER_NAMES = { Mod: 'Ctrl', Alt: 'Alt', Shift: 'Shift' };
const OTHER_ORDER = ['Mod', 'Alt', 'Shift'];     // Ctrl+Alt+Shift+key

/**
 * formatShortcut(['Mod', 'Shift'], 'S') → '⇧⌘S' on a Mac, 'Ctrl+Shift+S' elsewhere.
 * Modifiers are 'Mod' (⌘/Ctrl), 'Alt' (⌥/Alt) and 'Shift'.
 */
export function formatShortcut(modifiers, key) {
  if (isMac) {
    return MAC_ORDER.filter((m) => modifiers.includes(m)).map((m) => MAC_SYMBOLS[m]).join('') + key;
  }
  return [...OTHER_ORDER.filter((m) => modifiers.includes(m)).map((m) => OTHER_NAMES[m]), key].join('+');
}
